import React from "react";
import { useParams } from "react-router-dom";
import TriviaGame2024 from "src/components/holidays/TriviaGame2024";
import TriviaGame2025 from "src/components/holidays/TriviaiGame2025";
import Dashboard from "src/components/triviaGame/Dashboard";
import HolidayCard2022 from "../components/holidays/HolidayCard2022";
import HolidayCard2023 from "../components/holidays/HolidayCard2023";
import InvalidYear from "../components/holidays/InvalidYear";

export default function HolidayCardPage() {
  const { year } = useParams();

  switch (year) {
    case "2025":
      return <TriviaGame2025 />;
    case "2024":
      return <TriviaGame2024 />;
    case "2023":
      return <HolidayCard2023 />;
    case "2022":
      return <HolidayCard2022 />;
    case "stats":
      return <Dashboard />;
    default:
      return <InvalidYear />;
  }
}
